import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OverviewActivityStore {
  overviewActivity: boolean;
  setOverviewActivity: (active: boolean) => void;
  overviewShow: boolean;
  setOverviewShow: (show: boolean) => void;
}

export const useOverviewActivityStore = create<OverviewActivityStore>()(
  persist(
    set => ({
      overviewActivity: false,
      setOverviewActivity: active => set({ overviewActivity: active }),
      overviewShow: true,
      setOverviewShow: show => set({ overviewShow: show }),
    }),
    {
      name: 'overview-activity-storage',
    }
  )
);
